import styled from 'styled-components';
import { ContentSpacing, breakpoint } from 'elc-base-theme';
import { Subtitle3, Subtitle2 } from 'elc-typography';
import { IColorTitleProps } from '../../interfaces/IShadePicker';

export const SidebarButtonSection = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
    margin-bottom: ${ContentSpacing.space16};
    padding: 0 ${ContentSpacing.space8};
    ${breakpoint('desktop')`
        padding: 0;
    `};
`;

export const SelectAShadeLabel = styled(Subtitle2)`
    margin-left: ${ContentSpacing.space8};

    [dir='rtl'] & {
        margin-left: 0;
        margin-right: ${ContentSpacing.space8};
    }
`;

export const ColorTitle = styled(Subtitle3)`
    color: ${({ color }: IColorTitleProps) => color};
    line-height: 1;
    max-height: 3em;
    overflow: hidden;
    margin: ${ContentSpacing.space4} 0;
`;
